module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-check-fill-7655472f.svg";